import { cn } from '../../utils/classNames';
import useXCountStepper from '../../hooks/useXCountStepper';

const labelClasses = 'block mb-2 text-content font-sans';

const wrapperClasses = 'w-full';

const controlClasses = `
  flex h-10 w-full items-center justify-between
  bg-white border border-border rounded-md
  px-1
`;

const stepButtonClasses = `
  flex h-8 w-8 items-center justify-center rounded
  text-lg leading-none text-subtle
  transition-colors
  hover:text-primary
  disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:text-subtle
`;

// display only: a text input here would invite free text the validator then has to reject
const valueClasses = 'select-none font-sans text-base text-content';

const errorClasses = 'block mt-1 ml-1 text-sm text-danger';

const XCountStepper = ({ label, name, value, min = 1, max = 10, onChange, error }) => {
  const { canDecrement, canIncrement, decrement, increment } = useXCountStepper({
    value,
    min,
    max,
    onChange
  });

  return (
    <>
      {label && <label className={labelClasses}>{label}</label>}
      <div className={wrapperClasses}>
        <div className={cn(controlClasses, error && 'border-danger')}>
          <button
            type="button"
            className={stepButtonClasses}
            onClick={decrement}
            disabled={!canDecrement}
            aria-label={`Decrease ${label ?? name}`}
          >
            &minus;
          </button>
          <span className={valueClasses}>{value}</span>
          <button
            type="button"
            className={stepButtonClasses}
            onClick={increment}
            disabled={!canIncrement}
            aria-label={`Increase ${label ?? name}`}
          >
            +
          </button>
        </div>
        {error && <span className={errorClasses}>{error}</span>}
      </div>
    </>
  );
};

export default XCountStepper;
